import { observer } from "mobx-react-lite";
import fallbackImg from "../../assets/fallback_images/collectionSt.webp";
import Btn from "../Btn/Btn";
import ErrorIcon from "../Icons/ErrorIcon";
import SuccessIcon from "../Icons/SuccessIcon";
import { LazyImg } from "../LazyImg";
import s from "./TransactionResult.module.scss";

export interface TransactionResultProps {
  status: "success" | "error" | "custom";
  secondaryAction?: () => void;
  title?: string;
  imgURL?: string;
  reserveImgURL?: string;
  buttonTitle?: string;
  subtitle?: string | JSX.Element;
}

const TransactionResult: React.FC<TransactionResultProps> = observer(
  ({
    status,
    secondaryAction,
    title,
    subtitle,
    imgURL,
    reserveImgURL,
    buttonTitle,
  }) => {
    return (
      <div className={s.wrapper}>
        <div className={s.img}>
          {status === "success" && <SuccessIcon />}
          {status === "error" && <ErrorIcon />}
          {status === "custom" && (
            <div className={s.img_wrapper}>
              <LazyImg
                alt="Collection Preview"
                imgUrl={imgURL}
                reserveImgUrl={reserveImgURL}
                fallbackImgURL={fallbackImg}
              />
            </div>
          )}
        </div>
        <div className={s.title}>
          {status === "success" && (title ?? "Success")}
          {status === "error" && (title ?? "Something went wrong")}
          {status === "custom" && title}
        </div>
        <div className={s.text}>
          {status === "success" && subtitle}
          {status === "error" &&
            "Try to repeat the last action or go back to the main page"}
          {status === "custom" && subtitle}
        </div>
        <Btn
          height="56"
          className={s.btn}
          onClick={() => {
            secondaryAction?.();
          }}
        >
          {buttonTitle ?? "Close"}
        </Btn>
      </div>
    );
  }
);

export default TransactionResult;
